import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import NavigationBar from '../NavigationBar';
import Footer from '../Footer';

const NotFound = () => (
  <>
    <Helmet>
      <title>Page Not Found - SecurePaper App</title>
      <meta name="robots" content="noindex" />
    </Helmet>
    <NavigationBar />
    <div className="container text-center" style={{ padding: '6rem 1rem', minHeight: '50vh' }}>
      <h1 style={{ fontSize: '4rem' }}>404</h1>
      <h2 className="mb-3">Page not found</h2>
      <p className="text-muted mb-4">
        The page you are looking for doesn't exist or has been moved.
      </p>
      <div>
        <Link to="/" className="btn btn-primary mr-2">
          <i className="fa fa-home" aria-hidden="true"></i> Back to Dashboard
        </Link>
        <Link to="/create_encrypted_text" className="btn btn-outline-primary">
          <i className="fa fa-lock" aria-hidden="true"></i> Create SecurePaper
        </Link>
      </div>
    </div>
    <Footer />
  </>
);

export default NotFound;
